import Vue from 'vue'  // 加载vue环境
import App from './App.vue'  // 加载根组件
import router from './router'  // 加载路由环境
import "./assets/style/global.css"; //全局样式
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router: router,
  render: function (readVueFn) {
    return readVueFn(App);  // 读取FirstCP.vue替换index.html中的占位
  }
});